import type { ListingTemplateProduct } from "@/lib/listing-templates";

/** Safe indexed image access — returns `undefined` when the array is short. */
export function imageAt(product: ListingTemplateProduct, index: number) {
  return product.images?.[index];
}

/** First available image among the given indices, falling back to the first. */
export function pickImage(product: ListingTemplateProduct, indices: number[]) {
  for (const i of indices) {
    const img = product.images?.[i];
    if (img) return img;
  }
  return product.images?.[0];
}

/** Brand text, or `undefined` when missing/blank (lets sections hide cleanly). */
export function brandOf(product: ListingTemplateProduct) {
  return product.brand?.trim() || undefined;
}

/** Shipping / returns / support sections that actually have content. */
export function trustSections(product: ListingTemplateProduct) {
  return [product.shipping, product.returns, product.support].filter(
    (section) => section && section.lines && section.lines.length > 0,
  );
}
